import React, { useState, useEffect } from "react";

import Paper from "@mui/material/Paper";
import Container from "@mui/material/Container";
import { useDispatch, useSelector } from "react-redux";

import useForm from "../../../hooks/UseForm";
import { compiledName } from "../../../helpers";
import DisplayCurrency from "./DisplayCurrency";
import { GTM_EVENTS } from "../../../constants";
import { validateUserInfo } from "../../../validations";
import ProfileImageSection from "./ProfileImageSection";
import { StyledInfoForm } from "../Styles/SettingsStyles";
import Tracking from "../../../services/tracking.service";
import { profileActions } from "../../../store/actions";
import { MixPanelTrackedLink, ShowSpinnerOrLabel, UpdatePassword, UserContactInfo } from "../../../components";

export default function Settings() {
    const dispatch = useDispatch();
    const currentUserDetails = useSelector(state => state.authentication.current_user)
    const errors = useSelector(state => state.validationErrors);

    const [loading, setLoading] = useState(false);

    const [userContactDetails, setUserContactDetails] = useState({
        firstName: "",
        lastName: "",
        contactNumber: "",
        address: "",
        city: "",
        email: "",
        zipCode: "",
        displayCountry: { id: 0, name: "" },
        country: "",
        countryState: ""
    });

    const updateDetails = async () => {
        setLoading(true);
        const payload = {
            first_name: compiledName(userContactDetails.firstName),
            last_name: compiledName(userContactDetails.lastName),
            phone: userContactDetails.contactNumber,
            address: userContactDetails.address,
            city: userContactDetails.city,
            zip: userContactDetails.zipCode,
            id: userContactDetails.id,
            display_country_id: userContactDetails.displayCountry.id,
            country_state: userContactDetails.countryState,
            country_id: userContactDetails.country,
        };
        await dispatch(profileActions.updateContactInfo(payload));
        await dispatch(profileActions.fetchUserData());
        await dispatch(profileActions.getUserGraphData(userContactDetails.id));
        setLoading(false)

        Tracking.trackGTM({ event: GTM_EVENTS.PROFILE_INFO_UPDATE })
    }

    const handleInfoChange = (e) => {
        const { id, value } = e.target;
        if (id == "country") {
            value && setUserContactDetails({
                ...userContactDetails,
                country: value.id,
                countryState: ""
            })
        }
        else if (id == "countryState") {
            value && setUserContactDetails({
                ...userContactDetails,
                countryState: value.name
            })
        }
        else setUserContactDetails({
            ...userContactDetails,
            [id]: value
        })
    }

    const { handleChange, handleSubmit } = useForm(updateDetails, validateUserInfo, handleInfoChange, userContactDetails);

    const updateSelectedCurrency = (currency) => {
        setUserContactDetails({
            ...userContactDetails,
            displayCountry: {
                id: currency.db_id,
                name: currency.name
            }
        })
    }
    useEffect(() => {
        if (currentUserDetails) {
            setUserContactDetails({
                id: currentUserDetails.id,
                firstName: currentUserDetails.profiles.first_name,
                lastName: currentUserDetails.profiles.last_name,
                contactNumber: currentUserDetails.profiles.phone,
                address: currentUserDetails.profiles.address,
                city: currentUserDetails.profiles.city,
                email: currentUserDetails.email,
                zipCode: currentUserDetails.profiles.zip,
                displayCountry: {
                    id: currentUserDetails.profiles.display_country_id,
                    name: currentUserDetails.profiles.display_country_name,
                    code: currentUserDetails.profiles.display_country_code
                },
                country: currentUserDetails.profiles.country_id,
                countryState: currentUserDetails.profiles.state
            })
        }
    }, [currentUserDetails])

    return <StyledInfoForm spacing={2}>
        <Paper>
            <Container className="UpdateInfoContainer">
                <ProfileImageSection />

                <UserContactInfo
                    userContactDetails={userContactDetails}
                    validationErrors={errors}
                    handleInfoChange={handleChange}
                    allowEmailUpdation={false}
                />
                <DisplayCurrency updateSelectedCurrency={updateSelectedCurrency} contactDetails={userContactDetails} />

                <Container component='div' style={{ padding: 0, textAlign: 'end' }}>
                    <MixPanelTrackedLink
                        type="button"
                        label="Update Information"
                        context="Profile setting update information"
                        variant="outlined"
                        onClick={handleSubmit}
                        disabled={loading}
                    >
                        <ShowSpinnerOrLabel label="Update Information" loading={loading} />
                    </MixPanelTrackedLink>
                </Container>

            </Container>
        </Paper>
        <Paper>
            <UpdatePassword />
        </Paper>
    </StyledInfoForm>
}